import { render, staticRenderFns } from "./ProductMultipleTypeSummary.vue?vue&type=template&id=5dca9dec&"
import script from "./ProductMultipleTypeSummary.vue?vue&type=script&lang=js&"
export * from "./ProductMultipleTypeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports